import React, { Component } from 'react'
import { append, equals } from 'ramda'
import { AudienceBuilder, knownVisitors, anonVisitors } from '@driftt/audience-builder'
import { Loader } from '@driftt/tide-core-legacy'

import LoadingDots from 'components/shared/LoadingDots'

import './style.styl'

class AudienceBuilderContainer extends Component {

  shouldComponentUpdate(nextProps) {
    // TODO: change this to be a functional stateless component
    if (
      !equals(this.props.loading, nextProps.loading) ||
      // TODO: use array.every check instead for perf reasons
      !equals(this.getSelections(this.props), this.getSelections(nextProps)) ||
      !equals(this.props.isCardinalityLoading, nextProps.isCardinalityLoading) ||
      !equals(this.props.targetingCardinality, nextProps.targetingCardinality) ||
      !equals(this.props.usersSelected, nextProps.usersSelected) ||
      !equals(this.props.visitorsSelected, nextProps.visitorsSelected)
    ) {
      return true
    }

    return false
  }

  resolveUserListDataDisparity = () => {
    const { userListIds, usersSelected, visitorsSelected, noneSelected, onEveryoneClick } = this.props
    const included = userListIds.toJS()

    if (usersSelected) {
      return append(knownVisitors.id, included)
    } else if (visitorsSelected) {
      return append(anonVisitors.id, included)
    }

    if (noneSelected) {
      onEveryoneClick()
    }

    return included
  }

  getSelectedSmartFilters = () => {
    const { smartFilters } = this.props

    const filters = !smartFilters ? {} : !!smartFilters.toJS ? smartFilters.toJS() : smartFilters

    return filters
  }

  getSelections = () => ({
    selectedSendContacts: this.resolveUserListDataDisparity(),
    selectedDontSendContacts: this.props.excludedUserListIds.toJS(),
    selectedAccounts: this.props.accountListIds.toJS(),
    selectedDontSendAccounts: this.props.excludedAccountListIds.toJS(),
    selectedFilters: this.getSelectedSmartFilters()
  })

  render() {
    const {
      saveAudience,
      loading,
      isEmailPlaybook,
      targetingCardinality,
      isCardinalityLoading,
      hasAccountSegmentation,
      hasSmartFilterInclusion,
      hasAbandonedMeetingSmartFilter,
      hasLimitedContactsMktEmail,
    } = this.props

    return (
      <div className={`new-audience-builder ${hasAccountSegmentation ? 'new-audience-builder-with-account-segmentation' : ''}`}>
        { hasLimitedContactsMktEmail ?
          <header className="playbook-title-header">
            <h2>Build Your Audience</h2>
            <p>Who should receive this playbook?<br /> You can also choose who not to send to, and Drift will automatically exclude them.</p>
          </header> :
          <header className="playbook-title-header">
            <h2>Build Your Audience</h2>
            <p>
              Only the bot can add contacts or segments to send emails to.
              <br />
              You can still choose to exclude specific contacts and segments from receiving these emails.
            </p>
          </header>
        }
        {isEmailPlaybook && hasLimitedContactsMktEmail &&
          <div className="new-audience-builder-cardinality-label">
            <span>This email will send to</span>
            <span className="new-audience-builder-cardinality">{isCardinalityLoading ? <LoadingDots /> : targetingCardinality}</span>
            <span>contacts</span>
          </div>
        }
        {loading &&
          <div className="new-audience-builder-loader">
            <Loader />
          </div>
        }
        {!loading &&
          <AudienceBuilder
            selections={this.getSelections()}
            isChatPlaybook={!isEmailPlaybook}
            saveAudience={saveAudience}
            hasFeatureMap={{
              hasAccountSegmentation,
              hasSmartFilterInclusion,
              hasAbandonedMeetingSmartFilter,
              hasLimitedContactsMktEmail
            }}
            loading={false}
          />
        }
      </div>
    )
  }
}

export default AudienceBuilderContainer



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/TargetingAudience/AudienceBuilderContainer.js